import { render, staticRenderFns } from "./ThumbNote.vue?vue&type=template&id=148bec56&scoped=true&"
import script from "./ThumbNote.vue?vue&type=script&lang=ts&"
export * from "./ThumbNote.vue?vue&type=script&lang=ts&"
import style0 from "./ThumbNote.vue?vue&type=style&index=0&id=148bec56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148bec56",
  null
  
)

export default component.exports